// Library Methods
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// API
import { deleteClinicPackage } from "../../api";

export const useDeleteClinicPackage = (clinicId: string | undefined) => {
  const queryClient = useQueryClient();
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async (packageId: string) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        return deleteClinicPackage(token, clinicId, packageId);
      } catch (error) {
        throw error;
      }
    },
    // Invalidate clinic packages query cache
    onSuccess: (_) => {
      queryClient.invalidateQueries({
        queryKey: ["clinic-packages", clinicId],
      });
      setSnackbarInfo({
        variant: "success",
        message: t("Package deleted successfully!"),
      });
    },
    onError: () => {
      setSnackbarInfo({
        variant: "error",
        message: t("Package could not be deleted!"),
      });
    },
  });
};
